import React, { useState } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { CustomButton } from '../../Infra/CustomButton/CustomButton';
import { CustomAutocomplete } from '../../Infra/CustomAutocomplete/CustomAutocomplete';
import { FEE_TYPES, getFeeTypeDisplay, FeeType } from './feeTypeData';

interface FeeTypeSelectorProps {
  onAddFeeType: (feeTypeName: string) => void;
  existingFeeTypes: string[];
}

const FeeTypeSelector: React.FC<FeeTypeSelectorProps> = ({
  onAddFeeType,
  existingFeeTypes,
}) => {
  const [selectedFeeType, setSelectedFeeType] = useState<FeeType | null>(null);

  // Filter out fee types that already exist
  const availableFeeTypes = FEE_TYPES.filter(
    feeType => !existingFeeTypes.includes(feeType.displayName)
  );

  const handleAdd = () => {
    if (selectedFeeType) {
      onAddFeeType(selectedFeeType.displayName);
      setSelectedFeeType(null);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: 'grey.50',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'grey.300',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
        Add Fee Type
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <CustomAutocomplete
          value={selectedFeeType}
          onChange={(_, newValue) => setSelectedFeeType(newValue)}
          options={availableFeeTypes}
          getOptionLabel={option => getFeeTypeDisplay(option)}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Typography>{option.displayName}</Typography>
            </Box>
          )}
          placeholder="Search and select fee type..."
          textFieldProps={{ sx: { minWidth: 300 } }}
          sx={{ flex: 1 }}
        />
        <CustomButton
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          disabled={!selectedFeeType}
          size="small"
        >
          Add
        </CustomButton>
      </Stack>
    </Box>
  );
};

export default FeeTypeSelector;
